import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { products as fallbackProducts } from '../data/siteData';
import { getContentIcon, useCollectionData } from '../services/contentApi';
import './FeaturedProducts.css';

const FeaturedProducts = () => {
  const { items: products } = useCollectionData('products', fallbackProducts);
  const featured = products.filter((product) => product.badge).slice(0, 4);

  return (
  <section className="section featured-products">
    <div className="container">
      <div className="section-header">
        <div>
          <p className="eyebrow">Product preview</p>
          <h2 className="section-title">Clinical textiles built for repeated use.</h2>
        </div>
        <p className="section-sub">
          Woven and non-woven products selected for durability, patient comfort,
          laundering performance, and full procurement documentation.
        </p>
      </div>

      <div className="featured-grid">
        {featured.map((product, index) => {
          const { name, material, spec, feature, badge, tone, icon } = product;
          const Icon = getContentIcon(icon);
          return (
            <article className="featured-card stagger-card" key={name || index} style={{ '--delay': `${index * 90}ms` }}>
              <div className="featured-card-top">
                <span className={`icon-circle tone-${tone || 'blue'}`}>
                  <Icon size={24} strokeWidth={1.8} aria-hidden="true" />
                </span>
                <span className="featured-badge">{badge}</span>
              </div>
              <h3>{name}</h3>
              <p>{material}</p>
              <div className="featured-specs">
                <span>{spec}</span>
                <span>
                  <CheckCircle size={14} aria-hidden="true" />
                  {feature}
                </span>
              </div>
              <Link className="text-link" to="/products">
                View product details <ArrowRight size={17} aria-hidden="true" />
              </Link>
            </article>
          );
        })}
      </div>
    </div>
  </section>
  );
};

export default FeaturedProducts;
